"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventCheck = exports.isBusy = exports.checkAndConvertNumber = exports.toFormData = exports.unlockScroll = exports.lockScroll = exports.emptyToNull = exports.openAtPosition = exports.sortDelete = exports.findNextTask = exports.findPreviousTask = exports.pinToDeadline = exports.getProjectEnd = exports.getProjectStart = exports.dateRange = exports.checkCurrentDay = exports.checkCurrentWeek = exports.weekEnd = exports.weekStart = exports.uuid = exports.toBoolean = exports.clamp = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var ApiStore_1 = __importDefault(require("../stores/ApiStore"));
exports.clamp = function (min, value, max) {
    if (value < min)
        return min;
    if (value > max)
        return max;
    return value;
};
exports.toBoolean = function (string) { return string === 'true'; };
exports.uuid = function () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
};
exports.weekStart = function (date) {
    return date.day(0).startOf('d');
};
exports.weekEnd = function (date) {
    return date.day(6).startOf('d');
};
exports.checkCurrentWeek = function (date) {
    var now = exports.weekStart(dayjs_1.default().startOf('d'));
    return (exports.weekStart(date).isSame(now, 'date'));
};
exports.checkCurrentDay = function (date) {
    var now = dayjs_1.default().startOf('d');
    return (date.isSame(now, 'date'));
};
exports.dateRange = function (date) {
    return {
        start: exports.weekStart(date.subtract(1, 'w')),
        end: exports.weekEnd(date.add(5, 'w'))
    };
};
exports.getProjectStart = function (project) {
    if (project.startDate && !project.endDate)
        return dayjs_1.default(project.startDate).startOf('d');
    if (project.projectTasks.length === 0) {
        if (project.endDate)
            return dayjs_1.default(project.endDate).startOf('d').subtract(6, 'd');
        return dayjs_1.default().startOf('d');
    }
    var startDate = project.endDate ? dayjs_1.default(project.endDate).startOf('d') :
        project.projectTasks.length > 0 ? dayjs_1.default(project.projectTasks[0].startDate).startOf('d') : dayjs_1.default().startOf('d');
    for (var _i = 0, _a = project.projectTasks; _i < _a.length; _i++) {
        var task = _a[_i];
        var taskStart = dayjs_1.default(task.startDate);
        if (taskStart.isBefore(startDate))
            startDate = taskStart;
    }
    return startDate.startOf('d');
};
exports.getProjectEnd = function (project) {
    if (project.endDate)
        return dayjs_1.default(project.endDate).startOf('d');
    if (project.projectTasks.length === 0) {
        if (project.startDate)
            return dayjs_1.default(project.startDate).startOf('d').add(6, 'd');
        return dayjs_1.default().startOf('d').add(6, 'd');
    }
    var endDate = project.startDate ? dayjs_1.default(project.startDate).startOf('d') :
        project.projectTasks.length > 0 ? dayjs_1.default(project.projectTasks[0].endDate).startOf('d') : dayjs_1.default().startOf('d');
    for (var _i = 0, _a = project.projectTasks; _i < _a.length; _i++) {
        var task = _a[_i];
        var taskEnd = dayjs_1.default(task.endDate);
        if (taskEnd.isAfter(endDate))
            endDate = taskEnd;
    }
    return endDate.startOf('d');
};
exports.pinToDeadline = function (project) {
    var whichDate = 'endDate';
    if (!project.endDate) {
        if (!project.startDate)
            return project;
        whichDate = 'startDate';
    }
    var deadline = dayjs_1.default(project[whichDate]).startOf('d');
    var lastDate = project.endDate ? exports.getProjectStart(project) : exports.getProjectEnd(project);
    var tasks = [].slice.call(project.projectTasks);
    for (var _i = 0, _a = project.projectTasks; _i < _a.length; _i++) {
        var task = _a[_i];
        if (whichDate === 'endDate') {
            var taskEnd = dayjs_1.default(task.endDate).startOf('d');
            if (taskEnd.isAfter(lastDate))
                lastDate = taskEnd;
        }
        else {
            var taskStart = dayjs_1.default(task.startDate).startOf('d');
            if (taskStart.isBefore(lastDate))
                lastDate = taskStart;
        }
    }
    var diff = lastDate.diff(deadline, 'd');
    if (Math.abs(diff) > 0) {
        tasks = tasks.map(function (task) { return (__assign(__assign({}, task), { startDate: dayjs_1.default(task.startDate).subtract(diff, 'd').startOf('d').format(), endDate: dayjs_1.default(task.endDate).subtract(diff, 'd').startOf('d').format() })); });
    }
    return __assign(__assign({}, project), { projectTasks: tasks });
};
exports.findPreviousTask = function (task, project) {
    var previousTask = null;
    var startDate = exports.getProjectStart(project).subtract(1, 'd').startOf('d');
    for (var _i = 0, _a = project.projectTasks; _i < _a.length; _i++) {
        var projectTask = _a[_i];
        if (projectTask.id === task.id)
            continue;
        var projectTaskStart = dayjs_1.default(projectTask.startDate).startOf('d');
        if (projectTaskStart.isAfter(task.startDate))
            continue;
        if (dayjs_1.default(projectTask.startDate).startOf('d').isAfter(startDate)) {
            startDate = dayjs_1.default(projectTask.startDate).startOf('d');
            previousTask = projectTask;
        }
    }
    return previousTask;
};
exports.findNextTask = function (task, project) {
    var nextTask = null;
    var endDate = exports.getProjectEnd(project).startOf('d');
    for (var _i = 0, _a = project.projectTasks; _i < _a.length; _i++) {
        var projectTask = _a[_i];
        if (projectTask.id === task.id)
            continue;
        var projectTaskStart = dayjs_1.default(projectTask.startDate);
        if (projectTaskStart.isBefore(task.startDate))
            continue;
        if (dayjs_1.default(projectTask.startDate).startOf('d').isBefore(endDate)) {
            endDate = dayjs_1.default(projectTask.startDate).startOf('d');
            nextTask = projectTask;
        }
    }
    return nextTask;
};
exports.sortDelete = function (task, project) {
    var taskStart = dayjs_1.default(task.startDate).startOf('d');
    var taskEnd = dayjs_1.default(task.endDate).startOf('d');
    var taskLength = taskEnd.diff(taskStart, 'd') + 1;
    return exports.pinToDeadline(__assign(__assign({}, project), { projectTasks: project.projectTasks
            .filter(function (projectTask) { return projectTask.id !== task.id; })
            .map(function (projectTask) {
            var projectTaskStart = dayjs_1.default(projectTask.startDate).startOf('d');
            var projectTaskEnd = dayjs_1.default(projectTask.endDate).startOf('d');
            if (project.endDate) {
                return __assign(__assign({}, projectTask), { startDate: projectTaskStart.isAfter(taskStart) ? projectTask.startDate :
                        projectTaskStart.add(taskLength, 'd').format(), endDate: projectTaskStart.isAfter(taskStart) ? projectTask.endDate :
                        projectTaskEnd.add(taskLength, 'd').format() });
            }
            return __assign(__assign({}, projectTask), { startDate: projectTaskStart.isBefore(taskStart) ? projectTask.startDate :
                    projectTaskStart.subtract(taskLength, 'd').format(), endDate: projectTaskStart.isBefore(taskStart) ? projectTask.endDate :
                    projectTaskEnd.subtract(taskLength, 'd').format() });
        }) }));
};
exports.openAtPosition = function (position, scrollAmt) {
    var _a;
    var hDirection = position.x >= window.innerWidth * 0.75 ? 'right' : 'left';
    var hAmt = hDirection === 'right' ? (window.innerWidth - position.x) : position.x;
    var hInvert = hDirection === 'right' ? -1 : 1;
    var vAmt = position.y >= window.innerHeight * 0.5 ? position.y - 243 : position.y;
    return _a = {},
        _a[hDirection] = (100 / 6) + '%',
        _a.marginLeft = hInvert === -1 ? '0' : '-5rem',
        _a.marginTop = '-4rem',
        _a.transform = "translate(" + hAmt * hInvert + "px, " + (vAmt + scrollAmt) + "px)",
        _a;
};
exports.emptyToNull = function (value, format) {
    if (format === void 0) { format = false; }
    var formattedValue = value;
    if (format) {
        formattedValue = dayjs_1.default(value).startOf('d').format();
    }
    return value ? value.length <= 0 ? null : formattedValue : null;
};
exports.lockScroll = function () {
    document.body.setAttribute('data-scroll-locked', 'true');
};
exports.unlockScroll = function () {
    document.body.setAttribute('data-scroll-locked', 'false');
};
exports.toFormData = function (json) {
    var formData = new FormData();
    for (var k in json) {
        if (json.hasOwnProperty(k)) {
            formData.append(k, json[k]);
        }
    }
    return formData;
};
exports.checkAndConvertNumber = function (string) {
    var regEx = /^\d+$/;
    if (regEx.test(string)) {
        return parseFloat(string);
    }
    return string;
};
exports.isBusy = function (route) {
    return ApiStore_1.default.data.busyRoutes.includes(route);
};
exports.eventCheck = function (tbd) { return tbd.clientX && true || false; };
